<template>
  <div class="table">
    <div class="container">
      <el-row>
        <!--保存-->
        <el-button size="mini" class="btn" v-if="saveSubmitBtnShow" v-acl="QuotationSave" type="primary" @click="updateQuotation('save')">{{$t('common.save')}}</el-button>
        <!--提交-->
        <el-button size="mini" class="btn" v-if="saveSubmitBtnShow" v-acl="QuotationSave" type="primary" @click="updateQuotation('submit')">{{$t('common.submit')}}</el-button>
        <!--预估年总费用保存-->
        <el-button size="mini" class="btn" v-if="estimatedAnnualFeeBtnShow" type="primary" @click="updateQuotation('save')">{{$t('apply.annualTotalCostSave')}}</el-button>
        <!--关闭-->
        <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
      </el-row>
      <div class="handle-box">
        <el-form :model="headData" :label-position="labelPosition" ref="headDataForm" label-width="140px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="headData.applyNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('apply.applyType')" prop="applyType">
                <!--类型-->
                <el-select v-model="headData.applyType" :disabled="true" class="handle-input">
                  <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('apply.subject')">
                <!--主题-->
                <el-input class="handle-input" v-model="headData.subject" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                <!--报价类型-->
                <el-select v-model="headData.quotationType" class="handle-input" :disabled="true">
                  <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('common.createBy')">
                <!--创建人-->
                <el-input class="handle-input" v-model="headData.name" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('common.createDate')">
                <!--创建日期-->
                <el-input class="handle-input" v-model="headData.createDate" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('apply.lineDetail')" name="line">
          <!--线路报价明细-->
          <el-form ref="formTable" :rules="rules" :model="formTable" inline>
            <el-row type="flex" justify="start" align="middle" style="margin-bottom:5px">
              <el-form-item label="价格变动比例" v-if="saveSubmitBtnShow && headData.applyType==2">
                <el-input type="number" v-model="scale">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-row type="flex" justify="start" align="middle">
                  <el-button size="mini" class="btn" type="primary" v-if="saveSubmitBtnShow && headData.applyType==2" @click="batchRefresh">批量刷新</el-button>
                  <el-button size="mini" class="btn" type="primary" @click="exportDetail()">{{$t("common.export")}}</el-button>
                  <el-upload class="apply-import-button" v-if="saveSubmitBtnShow || estimatedAnnualFeeBtnShow" :on-error="importDetailError" :on-success="importDetailSuccess" :before-upload="beforeUpload" :show-file-list="false" :action="importDetailUrl" multiple="false" :headers="headers">
                    <el-button size="mini" type="primary">{{$t('common.import')}}</el-button>
                  </el-upload>
                </el-row>
              </el-form-item>
            </el-row>
            <ux-grid ref="quotationLineTableDataRef" :data="quotationLineTableData" keep-source max-height="550" highlight-current-row show-overflow="tooltip" :row-class-name="tableRowClassName">
              <ux-table-column align="center" title="操作" width="80" v-show="saveSubmitBtnShow||!estimatedAnnualFeeEditFlag">
                <template v-slot="scope">
                  <i class="el-icon-edit-outline" @click="onEdit(scope)"></i>
                </template>
              </ux-table-column>
              <ux-table-column align="center" title="序号" type="index" width="80"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.supplier')" field="supplierName" min-width="160px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.shippingCity')" field="pickupPoint" min-width="160px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.arrivalAarehouse')" field="dcName" min-width="160px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.temperature')" field="temperatureI18n" min-width="110px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.transportaionMethod')" field="transportaionMethod" min-width="120px">
                <template v-slot="scope">
                  {{scope.row.transportaionMethod | ic("COMMON",'TRANSPORTAION_METHOD')}}
                </template>
              </ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.unit')" field="unit" min-width="120px">
                <template v-slot="scope">
                  {{scope.row.unit | ic("COMMON",'UNIT')}}
                </template>
              </ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.effectiveBeginDate')" field="effectiveBeginDate" min-width="200px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.originalSupplier')" field="originalSupplier" min-width="160px" v-if="headData.applyType=='2'"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.originalPrice')" field="originalPrice" min-width="100" v-if="headData.applyType=='2'"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.priceNotTax')" field="price" min-width="170px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.currency')" field="currencyI18n" min-width="120"></ux-table-column>
              <ux-table-column align="center" sortable resizable title="LeadTime" field="leadTime" min-width="120"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.estimatedAnnualTotalCost')" field="estimatedAnnualFee" min-width="160px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('common.remarks')" field="remarks" min-width="220px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.lineStatus')" field="statusI18n" min-width="160px" v-show="headData.quotationType=='SUP'"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.lineType')" field="lineType" min-width="160px"></ux-table-column>
            </ux-grid>
          </el-form>
        </el-tab-pane>
        <!--供应商附件-->
        <el-tab-pane :label="$t('common.attachment')" name="enclosure">
          <!--附件-->
          <el-row align="middle" :gutter="10" v-for="(supplier,ix) in supplierList" :key="ix">
            <el-col :span="4">
              {{supplier.supplierCode}}
            </el-col>
            <el-col :span="20">
              <el-table :data="fileList[ix]" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
                <!--创建人-->
                <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
                  <!--创建时间-->
                  <template slot-scope="scope">
                    {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
                  </template>
                </el-table-column>

                <el-table-column show-overflow-tooltip v-if="showUploadFlag" prop="tmDocumentId" min-width="130px">
                  <template slot-scope="scope">
                    <!--删除-->
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList[ix])">{{$t('common.del')}}</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="showUploadFlag" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" multiple :on-remove="removeFile" :file-list="showFileList" name="file">
                <el-button slot="trigger" size="mini" type="primary">{{$t('common.selectFile')}}</el-button>
                <!--选取文件-->
              </el-upload>
              <el-button v-if="showUploadFlag" size="mini" style="margin-left: 15px" type="success" @click="submitUpload(supplier.tmSupplierId,ix)">{{$t('common.upload')}}</el-button>
              <!--上传-->
            </el-col>
          </el-row>
          <!--供应商附件-->
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
        <el-table :data="tableData" ref="tableDataRef" border highlight-current-row max-height="470">
          <!--供应商-->
          <el-table-column show-overflow-tooltip sortable prop="supplierName" :label="$t('apply.supplier')" min-width="160px" fixed></el-table-column>
          <!--发货市-->
          <el-table-column sortable prop="pickupPoint" :label="$t('apply.shippingCity')" min-width="160px"></el-table-column>
          <!--到货仓库-->
          <el-table-column sortable prop="dcName" :label="$t('apply.arrivalAarehouse')" min-width="160px"></el-table-column>
          <!--温区-->
          <el-table-column sortable prop="temperatureI18n" :label="$t('apply.temperature')" min-width="110px"></el-table-column>
          <!--运输方式-->
          <el-table-column sortable prop="transportaionMethod" :label="$t('apply.transportaionMethod')" min-width="120px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.transportaionMethod">
                <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--结算单位-->
          <el-table-column sortable prop="unit" :label="$t('apply.unit')" min-width="120px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.unit">
                <el-option :key="index" v-for="(item,index) in unitList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- 有效开始日期-->
          <el-table-column sortable prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')" min-width="200px">
            <template slot-scope="scope">
              <el-date-picker v-if="headData.applyType=='2'" :picker-options="dateLimit" style="width: 100%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
              <el-date-picker v-else style="width: 100%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
            </template>
          </el-table-column>
          <!--原供应商-->
          <el-table-column v-if="headData.applyType=='2'" sortable prop="originalSupplier" :label="$t('apply.originalSupplier')" min-width="160px"></el-table-column>
          <!--原价格-->
          <el-table-column v-if="headData.applyType=='2'" sortable prop="originalPrice" :label="$t('apply.originalPrice')" min-width="80px"></el-table-column>
          <!--报价（不含税）-->
          <el-table-column sortable prop="price" :label="$t('apply.priceNotTax')" width="170px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.price" @blur="setPrice(scope.row.price,scope.$index)"></el-input>
            </template>
          </el-table-column>
          <!--币种-->
          <el-table-column sortable prop="tcCurrencyId" :label="$t('apply.currency')" width="160px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.tcCurrencyId" :filterable="true" @change="currencyChange($event,scope.row)">
                <el-option value="">{{$t('common.pleaseSelect')}}</el-option>
                <el-option :key="index+1" v-for="(item,index) in currencyList" :label="item.currencyCode" :value="item.tcCurrencyId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column sortable prop="leadTime" label="LeadTime" width="160px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.leadTime"></el-input>
            </template>
          </el-table-column>
          <!--预估年总费用-->
          <el-table-column sortable prop="estimatedAnnualFee" :label="$t('apply.estimatedAnnualTotalCost')" width="160px">
            <template slot-scope="scope">
              <el-input :disabled="estimatedAnnualFeeEditFlag" v-model="scope.row.estimatedAnnualFee"></el-input>
            </template>
          </el-table-column>
          <!--备注-->
          <el-table-column prop="remarks" :label="$t('common.remarks')" width="220px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks"></el-input>
            </template>
          </el-table-column>
          <!--条目状态-->
          <el-table-column v-show="headData.quotationType=='SUP'" prop="statusI18n" :label="$t('apply.lineStatus')" min-width="160px"></el-table-column>
          <!-- 线路类型 -->
          <el-table-column sortable prop="lineType" :label="$t('apply.lineType')" width="160px"></el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px;">
          <el-button type="primary" @click="onConfirm">确认</el-button>
          <el-button type="primary" @click="onCancel">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import { quotationService } from "../../../api/quotation-apply/quotation-service";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import commonConstants from "@/constants/commonConstants";
export default {
  name: 'quotation-detaill',
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `quotation/importDetail/${this.ttQuotationId}`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    }
  },
  data() {
    return {
      loadingInstance: null,
      dialogEditVisible: false,
      tableData: [],
      index: null,
      scale: '',//比例
      ttQuotationId: null,
      ttQuotationApplyRoundId: null,
      labelPosition: 'right',
      headData: {},
      activeName: 'line',
      applyTypeList: [],
      quotationTypeList: [],
      temperatureList: [],
      transportaionMethodList: [],
      unitList: [],
      currencyList: [],
      saveSubmitBtnShow: false,
      showUploadFlag: false,
      fileList: [],
      quotationLineTableData: [],
      supplierList: [],
      showFileList: [],
      uploadFileList: [],
      comeForm: '',//用于记录来源,主要用于结束询价的预估年总费用维护
      estimatedAnnualFeeEditFlag: true,//控制预估年总费用是否可编辑
      estimatedAnnualFeeBtnShow: false,//控制预估年总旨用保存按钮显示
      applyCreateDate: null,
      dateLimit: {},
      saveSubmit: ''
    }
  },
  created() {
    this.ttQuotationApplyRoundId = this.$route.params.roundId;
    this.comeForm = this.$route.params.from;
    this.getInputChoiceValues();
    this.quotationPageInitM(this.$route.params.roundId);
  },
  watch: {
    applyCreateDate(newTime, oldTime) {
      let _this = this;
      let createDateString = _this.applyCreateDate;
      this.dateLimit = {
        disabledDate(time) {
          let str = createDateString.replace(/-/g, '/');
          let date = new Date(str);
          date.setMonth(date.getMonth() + 1)
          date.setDate(1);
          return time.getTime() < date;//- 8.64e7; // - 8.64e7 表示可选择当天时间
        }
      }
    }
  },
  methods: {
    quotationPageInitM(param) {
      let _this = this;
      quotationService.quotationInit(param).then((res) => {
        _this.ttQuotationId = res.ttQuotationId;
        _this.headData = res.quotationApply;
        _this.applyCreateDate = res.quotationApply.createDate;
        _this.quotationLineTableData = res.quotationLineList;
        _this.supplierList = res.supplierList;
        if (!!res.supplierList) {
          _this.fileList = [];
          res.supplierList.forEach((sup, index) => {
            _this.fileList.push([]);
            _this.getFiles(sup.tmSupplierId, index);
          })
        }
        //不是报价中的报价单不可以编辑,供应商报价不可编辑
        if ('1' == res.status && res.quotationApply.quotationType == 'MCD' && res.ownerFlag == true) {
          _this.saveSubmitBtnShow = true;
          _this.showUploadFlag = true;
          _this.estimatedAnnualFeeEditFlag = false;
        }
        if (_this.comeForm == 'eq' && '2' == res.status) {
          //来自于结束询价时预算年总费用维护，控制只能编辑单一字段
          _this.estimatedAnnualFeeBtnShow = true;
          _this.estimatedAnnualFeeEditFlag = false;
        } else if ('1' == res.otherStatus) {
          _this.estimatedAnnualFeeBtnShow = true;
          _this.estimatedAnnualFeeEditFlag = false;
          _this.comeForm = 'eq';
        }
        this.$refs.quotationLineTableDataRef.reloadData(res.quotationLineList)
      });
    },
    setPrice(price, index) {
      if (price.indexOf('-') != -1) {
        price = price.replace(/-/g, '')
      }
      var val = parseFloat(price)
      if (isNaN(val)) {
        return false
      }
      val = Math.round(val * 1000000) / 1000000
      this.tableData[index].price = val
    },
    onEdit(scope) {
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.tableData.push(JSON.parse(JSON.stringify(scope.row)))
    },
    onCancel() {
      this.dialogEditVisible = false
      this.tableData = []
    },
    onConfirm() {
      console.log('this.tableData[0]', this.tableData[0]);
      this.$refs.quotationLineTableDataRef.reloadRow(this.$refs.quotationLineTableDataRef.data[this.index], this.tableData[0], null)
      console.log('this.$refs.quotationLineTableDataRef.data[this.index]', this.$refs.quotationLineTableDataRef.data);
      this.dialogEditVisible = false
      setTimeout(() => {
        this.tableData = []
      }, 500);
    },
    currencyChange(val, row) {
      var arr = this.currencyList.filter(ele => {
        return ele.tcCurrencyId === val
      })
      this.$set(row, 'currencyI18n', arr[0].currencyCode)
    },
    exportDetail() {
      quotationService.exportDetail(this.ttQuotationId).then(resp => {
        if (this.estimatedAnnualFeeBtnShow) {
          fileService.respToFile(resp, 'RFQ(Line)-预估年总费用' + this.headData.applyNo + '.xlsx');
        } else {
          fileService.respToFile(resp, 'RFQ(Line)-' + this.headData.applyNo + '.xlsx');
        }
      })
    },
    beforeUpload(file) {
      this.loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    importDetailSuccess(resp) {
      if (resp.code === '200') {
        this.loadingInstance.close();
        this.$message.success('导入完成,已导入数据' + resp.data + '条')
        this.quotationPageInitM(this.$route.params.roundId);
      } else {
        this.$message.error(resp.msg)
      }
    },
    importDetailError(resp) {
      this.loadingInstance.close();
      Message.error(JSON.parse(resp.message).msg);
    },
    //文件下载
    downloadFile(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件删除
    deleteFile(tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //文件列表数据获取
    getFiles(supId, index) {
      let _this = this;
      let attachment = {};
      attachment.seq = supId + '';
      attachment.tsRecId = this.ttQuotationId;
      attachment.tsReckindId = 'QUOTATION';
      fileService.getFileList(attachment).then((fileRes) => {
        _this.$set(_this.fileList, index, fileRes);
      })
    },
    removeFile(file, fileList) {
      this.uploadFileList = [];
      fileList.forEach((file) => {
        this.uploadFileList.push(file.raw);
      });
    },
    //文件上传
    submitUpload(supId, ix) {
      let _this = this;
      let formData = new FormData();
      this.uploadFileList.forEach((file) => {
        formData.append("file", file);
      });
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = supId + '';
        attachment.tsRecId = this.ttQuotationId;
        attachment.tsReckindId = 'QUOTATION';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles(supId, ix);
          _this.uploadFileList = [];
          _this.showFileList = [];
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件上传
    uploadConfirm(item) {
      this.uploadFileList.push(item.file);
    },
    historyBack() {
      this.$router.replace({
        path: '/quotation'
      });
    },
    updateQuotation(method) {
      let that = this
      let quotationInfo = {};
      quotationInfo.method = method;
      quotationInfo.ttQuotationId = this.ttQuotationId;
      quotationInfo.quotationLineList = this.quotationLineTableData;
      console.log(quotationInfo)
      let dcPP = this.validateApplyLineTableData(this.quotationLineTableData);
      if (!dcPP) {
        Message({ message: '提货点或到货仓库信息不完整，无法继续进行报价！', type: "error" });
        return;
      }
      this.saveSubmit = method;
      // let validFlag = false;
      // if (!commonFun.validForm(this.quotationLineTableData, this.rules, '')) {
      //   return;
      // }
      quotationInfo.otherFlag = this.comeForm;
      if (method == "submit") {
        for (let i = 0; i < quotationInfo.quotationLineList.length; i++) {
          let item = quotationInfo.quotationLineList[i];
          if (commonFun.isEmpty(item.effectiveBeginDate)) {
            that.$message({ message: '第' + (i + 1) + '行' + "有效日期不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.transportaionMethod)) {
            that.$message({ message: '第' + (i + 1) + '行' + "运输方式不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.unit)) {
            that.$message({ message: '第' + (i + 1) + '行' + "结算单位不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.tcCurrencyId)) {
            that.$message({ message: '第' + (i + 1) + '行' + "币种不能为空", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.leadTime)) {
            that.$message({ message: '第' + (i + 1) + '行' + "LeadTime不能为空", type: "warning" });
            return;
          }
          if (commonFun.unicodeLength(item.remarks) > 500) {
            that.$message({ message: '第' + (i + 1) + '行' + "备注超出系统支持长度,请精减！", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.price)) {
            that.$message({ message: '第' + (i + 1) + '行' + "报价(不含税)不能为空", type: "warning" });
            return;
          }
          if (isNaN(((item.price + "").trim()) * 1)) {
            that.$message({ message: '第' + (i + 1) + '行' + "请正确输入报价(不含税)!", type: "warning" });
            return;
          }
          if (commonFun.isEmpty(item.estimatedAnnualFee)) {
            that.$message({ message: '第' + (i + 1) + '行' + "预估年总费用不能为空", type: "warning" });
            return;
          }
          if (isNaN(((item.estimatedAnnualFee + "").trim()) * 1)) {
            that.$message({ message: '第' + (i + 1) + '行' + "请正确输入预估年总费用!", type: "warning" });
            return;
          }
        }
        that.$confirm(that.$t('apply.sureSubmit'), that.$t('common.tips'), {
          confirmButtonText: that.$t('common.confirm'),
          cancelButtonText: that.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          quotationService.updateQuotationLine(quotationInfo).then((res) => {
            Message({ message: this.$t('common.submitSuccess'), type: "success" });
            this.historyBack();
          });
        }).catch(() => {

        });
      } else {
        quotationService.updateQuotationLine(quotationInfo).then((res) => {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
        });
      }

    },
    validateApplyLineTableData(applyLineTableData) {
      let returnFlag = true;
      if (!!applyLineTableData) {
        applyLineTableData.forEach(item => {
          if ((!item.dcName) || (!item.pickupPoint)) {
            returnFlag = false;
          }
        })
      }
      return returnFlag;
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      mapObj["COMMON:UNIT"] = "COMMON:UNIT";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
        this.unitList = res["COMMON:UNIT"];
      });
      inputChoiceService.getCurrencyList().then((res) => {
        this.currencyList = res;
        console.log('currencyList', this.currencyList);
      });
    },
    //清除校验信息
    clearVlidate(refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    //批量刷新
    batchRefresh() {
      let that = this
      let scale = that.scale
      if (scale != "") {
        let dataTable = that.quotationLineTableData
        for (let i = 0; i < dataTable.length; i++) {
          dataTable[i].price = parseFloat(scale) / 100 * parseFloat(dataTable[i].originalPrice) + parseFloat(dataTable[i].originalPrice)
        }
        that.quotationLineTableData = dataTable;
      }

    },
    tableRowClassName({ row, rowIndex }) {
      if (row.colour === 'Y') {
        return 'success-row-q';
      } else {
        return '';
      }
    }
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 10px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.el-table .success-row-q {
  background: #ffa796;
}
</style>
